module.exports = __webpack_public_path__ + "static/media/checkbox.cccb2c1f.svg";